import { createAsyncSagaAction } from 'utils/reduxUtils';
import * as actionTypes from './actionTypes';

export const fetchStatesAndCountries = createAsyncSagaAction(
  actionTypes.FETCH_STATES_AND_COUNTRIES,
);
export const fetchGeocodingAddresses = createAsyncSagaAction(actionTypes.FETCH_GEOCODING_ADDRESSES);
export const saveGeocodingAddress = createAsyncSagaAction(actionTypes.SAVE_GEOCODING_ADDRESS);
export const checkLocationName = createAsyncSagaAction(actionTypes.CHECKLOCATIONNAME);
export const getLocationList = createAsyncSagaAction(actionTypes.GET_LOCATION_LIST);
export const saveOrUpdateLocations = createAsyncSagaAction(actionTypes.SAVE_OR_UPDATE_LOCATION);
export const deleteLocation = createAsyncSagaAction(actionTypes.DELETE_LOCATION);
export const saveOrUpdateExpectedLocations = createAsyncSagaAction(actionTypes.SAVE_OR_UPDATE_EXPECTED_LOCATION);
export const deleteExpLocation = createAsyncSagaAction(actionTypes.DELETE_EXP_LOCATION);
export const getExpectedLocationList = createAsyncSagaAction(actionTypes.GET_EXPECTED_LOCATION_LIST);

export const editLocation = fields => ({
  type: actionTypes.EDIT_LOCATION,
  payload: fields,
});
export const verifyLocation = fields => ({
  type: actionTypes.VERIFY_LOCATION,
  payload: fields,
});
export const deleteSummaryItem = fields => ({
  type: actionTypes.DELETE_SUMMARY_ITEM,
  payload: fields,
});
